export class OpeningHour {
    day!: number
    fromTime!: string
    toTime!: string
    isEnabled!: boolean
  }